import { render, staticRenderFns } from "./policyAndCustomerBirthCheck.vue?vue&type=template&id=51114b30&scoped=true"
import script from "./policyAndCustomerBirthCheck.vue?vue&type=script&lang=js"
export * from "./policyAndCustomerBirthCheck.vue?vue&type=script&lang=js"
import style0 from "./policyAndCustomerBirthCheck.vue?vue&type=style&index=0&id=51114b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51114b30",
  null
  
)

export default component.exports